import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Advisory from './pages/Advisory';
import About from './pages/About';
import Report from './pages/Report';
import Commons from './pages/Commons';
import Security from './pages/Security';
import Donate from './pages/Donate';
import Findings from './pages/Findings';
import Admin from './pages/Admin';

const Navbar: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 glass border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-black flex items-center justify-center rounded-sm">
                <span className="text-white font-bold text-sm tracking-tighter">S.A.</span>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-black tracking-widest text-slate-900">SYSTEM AUDIT</span>
                <span className="text-[10px] font-bold text-slate-400 tracking-[0.2em] uppercase">Forensic Accountability</span>
              </div>
            </Link>
          </div>
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className={`text-xs uppercase tracking-widest font-bold transition-colors ${isActive('/') ? 'text-black' : 'text-slate-500 hover:text-black'}`}>Home</Link>
            <Link to="/about" className={`text-xs uppercase tracking-widest font-bold transition-colors ${isActive('/about') ? 'text-black' : 'text-slate-500 hover:text-black'}`}>About</Link>
            <Link to="/findings" className={`text-xs uppercase tracking-widest font-bold transition-colors ${isActive('/findings') ? 'text-black' : 'text-slate-500 hover:text-black'}`}>Investigations</Link>
            <Link to="/advisory" className={`text-xs uppercase tracking-widest font-bold transition-colors ${isActive('/advisory') ? 'text-black' : 'text-slate-500 hover:text-black'}`}>Advisory</Link>
            <Link to="/commons" className={`text-xs uppercase tracking-widest font-bold transition-colors ${isActive('/commons') ? 'text-black' : 'text-slate-500 hover:text-black'}`}>The Commons</Link>
            <Link to="/report" className="px-5 py-2.5 bg-black text-white rounded-none text-xs font-bold uppercase tracking-widest hover:bg-slate-800 transition-all">
              Secure Portal
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

const Footer: React.FC = () => (
  <footer className="bg-[#0a0a0a] text-white pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-20">
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-10 h-10 bg-white flex items-center justify-center rounded-sm">
              <span className="text-black font-bold text-sm tracking-tighter">S.A.</span>
            </div>
            <span className="text-2xl font-black tracking-widest">SYSTEM AUDIT</span>
          </div>
          <p className="text-slate-500 text-sm max-w-md leading-relaxed">
            Independent institutional accountability and forensic risk mitigation. Registered in the United States to protect global disclosure and First Amendment rights.
          </p>
        </div>
        <div>
          <h4 className="text-[10px] font-bold mb-6 uppercase tracking-[0.3em] text-slate-400">Jurisdiction</h4>
          <ul className="space-y-3 text-xs font-medium text-slate-500">
            <li><Link to="/about" className="hover:text-white transition-colors">Legal Safe Harbor</Link></li>
            <li><Link to="/security" className="hover:text-white transition-colors">Data Protocol</Link></li>
            <li><Link to="/donate" className="hover:text-white transition-colors">Investigative Fund</Link></li>
            <li><a href="#" className="hover:text-white transition-colors">Section 230 Disclosure</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[10px] font-bold mb-6 uppercase tracking-[0.3em] text-slate-400">Communications</h4>
          <ul className="space-y-3 text-xs font-medium text-slate-500">
            <li>Signal: +1 [SECURE]</li>
            <li>PGP: 0x8A...EF92</li>
            <li>press@systemaudit.org</li>
            <li>hq@systemaudit.org</li>
          </ul>
        </div>
      </div>
      <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-[10px] font-bold uppercase tracking-widest text-slate-600">
        <div>© {new Date().getFullYear()} System Audit Organization. Global Safe Harbor.</div>
        <div className="flex space-x-6">
          <a href="#" className="hover:text-white">Privacy Policy</a>
          <a href="#" className="hover:text-white">Terms of Use</a>
          <a href="#" className="hover:text-white">Ethics Charter</a>
        </div>
      </div>
    </div>
  </footer>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col selection:bg-orange-500 selection:text-white">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/advisory" element={<Advisory />} />
            <Route path="/about" element={<About />} />
            <Route path="/findings" element={<Findings />} />
            <Route path="/report" element={<Report />} />
            <Route path="/commons" element={<Commons />} />
            <Route path="/security" element={<Security />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
